import { IBarrier, IPaginatedREST } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export interface IBarriersListFilters {
    /** Number of itens per page */
    perPage?: number
    /** Page to request page start in 1 */
    page?: number
    /** String to search */
    keyword?: string
    direction?: 'ASC' | 'DESC'
    orderBy?: string
    filterBy?: number
    root?: string
}

const isListNullOrEmpty = (list: unknown[]): boolean => {
    return !(list && list.length > 0)
}

export const transformJsonConfigIntoString = (bar: IBarrier): void => {
    if (bar) {
        if (bar.updateModeJsonConfig) {
            if (!(typeof (bar.updateModeJsonConfig) === 'string')) {
                bar.updateModeJsonConfig = JSON.stringify(bar.updateModeJsonConfig)
            }
        }
        if (!isListNullOrEmpty(bar.escalations)) {
            for (const esc of bar.escalations) {
                if (esc.updateModeJsonConfig) {
                    esc.updateModeJsonConfig = JSON.stringify(esc.updateModeJsonConfig)
                }
                if (!isListNullOrEmpty(esc.barriers)) {
                    for (const childBar of esc.barriers) {
                        transformJsonConfigIntoString(childBar)
                    }
                }
            }
        }
    }
}
export const transformJsonConfigIntoObject = (bar: IBarrier): void => {
    if (bar) {
        if (bar.updateModeJsonConfig) {
            bar.updateModeJsonConfig = JSON.parse(bar.updateModeJsonConfig as string)
        }
        if (!isListNullOrEmpty(bar.escalations)) {
            for (const esc of bar.escalations) {
                if (esc.updateModeJsonConfig) {
                    esc.updateModeJsonConfig = JSON.parse(esc.updateModeJsonConfig as string)
                }
                if (!isListNullOrEmpty(esc.barriers)) {
                    for (const childBar of esc.barriers) {
                        transformJsonConfigIntoObject(childBar)
                    }
                }
            }
        }
    }
}

export const listBarriers = async (params?: IBarriersListFilters): Promise<IPaginatedREST<IBarrier>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: ((params?.page ?? 1) - 1).toString() ?? '',
        keyword: params?.keyword ?? '',
        direction: params?.direction ?? 'ASC',
        orderBy: params?.orderBy?.toUpperCase() ?? 'ID',
        asset: params?.filterBy?.toString() ?? '',
        rootFilter: params?.root?.toString() ?? 'true'
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barriers}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}

export const getBarrier = async (id?: number): Promise<IBarrier> => {
    if (!id) {
        return undefined
    }

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barriers}/${id}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            transformJsonConfigIntoObject(jsonData)

            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createBarrier = async (body: Pick<IBarrier, 'name' | 'root' | 'asset' | 'method'>): Promise<IBarrier> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barriers}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateBarrier = async (body: IBarrier): Promise<IBarrier> => {
    transformJsonConfigIntoString(body)

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barriers}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const deleteBarrier = async (id: number): Promise<void> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barriers}/${id}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
